import { render, staticRenderFns } from "./base-spinner.vue?vue&type=template&id=deae880e&scoped=true&"
import script from "./base-spinner.vue?vue&type=script&lang=ts&"
export * from "./base-spinner.vue?vue&type=script&lang=ts&"
import style0 from "./base-spinner.vue?vue&type=style&index=0&id=deae880e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae880e",
  null
  
)

export default component.exports